export default function maskInput(pattern: string, input: string) {
    if (input === undefined || input === null) {
        return "";
    }

    let result = input;
    for (let i = 0; i < pattern.length && i < result.length; i++) {
        if (isNaN(parseInt(pattern[i]))) {
            if (result[i] !== pattern[i]) {
                result = result.slice(0, i).concat(pattern[i], result.slice(i));
            }
        } else {
            while (result.length > i && isNaN(parseInt(result[i]))) {
                result = result.slice(0, i).concat(result.slice(i + 1));
            }
        }
    }

    return result.slice(0, pattern.length);
}
